import { render, staticRenderFns } from "./TargetMapping.vue?vue&type=template&id=0fb85610&scoped=true"
import script from "./TargetMapping.vue?vue&type=script&lang=js"
export * from "./TargetMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb85610",
  null
  
)

export default component.exports